// List of ggfx api based env for handling more than once ggfx server in website
// DYNAMIC ENV fetch from process.env not working so this file required if more than one ggfx server used
export default {
    GATSBY_STRAPI_FEED_SRC: process.env.GATSBY_STRAPI_FEED_SRC,
    GATSBY_STRAPI_FEED_AUTH_TOKEN: process.env.GATSBY_STRAPI_FEED_AUTH_TOKEN
};
